import { FC } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import AuthShell from '../auth/AuthShell';

const NotFoundPage: FC = () => {
  const navigate = useNavigate();

  return (
    <AuthShell
      title="Page not found"
      subtitle="The page may have moved or the address may be incorrect."
    >
      <Stack spacing={1.5}>
        <Typography color="text.secondary" textAlign="center">
          Use one of the options below to return to a familiar place.
        </Typography>
        <Button component={RouterLink} to="/" variant="contained">
          Go to home
        </Button>
        <Button variant="outlined" onClick={() => navigate(-1)}>
          Go back
        </Button>
      </Stack>
    </AuthShell>
  );
};

export default NotFoundPage;
